import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import {Box, Text, Button} from '@salesforce/retail-react-app/app/components/shared/ui'

import {getStores} from '../../../../hooks/use-store-search'
import useTagManager from '../../../../hooks/use-tag-manager'

const SearchByLocation = ({
    setSearchTerm,
    setStores,
    showPermissionError,
    setShowPermissionError
}) => {
    const api = useCommerceApi()
    const tagManager = useTagManager()
    const {proxy} = api.shopperExperience.clientConfig
    const {getTokenWhenReady} = useAccessToken()
    const [isLoading, setIsLoading] = useState(false)

    const handleGetStores = async (coordinates) => {
        const {latitude, longitude} = coordinates?.coords || {latitude: null, longitude: null}

        if (latitude && longitude) {
            tagManager.bopisFindMyStore(coordinates)
            setStores(null)
            setIsLoading(true)

            try {
                const data = await getStores({
                    parameters: {
                        c_lat: latitude,
                        c_long: longitude,
                        c_type: 'findbygeolocation'
                    },
                    getTokenWhenReady,
                    proxy
                })

                if (data?.stores) {
                    setStores(data.stores)
                } else {
                    setStores([])
                }
                tagManager.useMyLocation()
                setIsLoading(false)
            } catch (error) {
                console.error('Error fetching location:', error)
                setStores([])
                setIsLoading(false)

                return
            }
        } else {
            setShowPermissionError(true)
        }
    }

    const handleUseMyLocation = () => {
        setSearchTerm('')
        setStores(null)
        setShowPermissionError(false)
        if (navigator?.geolocation) {
            navigator.geolocation.getCurrentPosition(handleGetStores, (error) => {
                console.error('Error fetching location:', error)
                setShowPermissionError(true)
            })
        } else {
            setShowPermissionError(true)
        }
    }

    return (
        <Box textAlign="right">
            <Button
                onClick={handleUseMyLocation}
                isLoading={isLoading}
                variant="linkUnderline"
                fontSize="14px"
                fontWeight="400"
                lineHeight="20px"
                textUnderlineOffset="4px"
                letterSpacing="0.5px"
                color="black.100"
            >
                <FormattedMessage
                    id="select_store_modal.use_my_location"
                    defaultMessage="Use my location"
                />
            </Button>

            {showPermissionError && (
                <Text
                    textAlign="left"
                    fontSize="14px"
                    fontWeight="400"
                    lineHeight="20px"
                    letterSpacing="0.5px"
                    color="red.400"
                >
                    <FormattedMessage
                        id="select_store_modal.geolocation_permission_error"
                        defaultMessage="Please enable location services in your browser settings."
                    />
                </Text>
            )}
        </Box>
    )
}

SearchByLocation.propTypes = {
    setSearchTerm: PropTypes.func.isRequired,
    setStores: PropTypes.func.isRequired,
    showPermissionError: PropTypes.bool.isRequired,
    setShowPermissionError: PropTypes.func.isRequired
}

export default SearchByLocation
